// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1VL7D","inputWrap":"styles_inputWrap__1N4m7","input":"styles_input__3mpOE"};